import * as R from 'ramda'

import buildSkuName from '../../modules/buildSkuName.js'

export default {
  '': [
    {
      src: 'buyerRef',
      fill: buyerRef => {
        const buyer = R.pick(
          ['_id', 'key', 'contact', 'phone', 'fax', 'email'],
          buyerRef,
        )

        return { buyer }
      },
    },
    {
      src: 'stafferRef',
      fill: stafferRef => {
        const staffer = R.pick(['_id', 'key', 'phone', 'email'], stafferRef)

        return { staffer }
      },
    },
  ],
  'items.0': {
    src: 'skuRef',
    fill: sku => ({
      sku,
      name: buildSkuName(sku),
    }),
  },
}
